import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import withCustomComponent from 'ui/components/withCustomComponent';

@withCustomComponent('BenefitsRow')
@withTranslation()
class BenefitsRowBW extends Component {
  static propTypes = {
    name: PropTypes.string,
    valueMin: PropTypes.number,
    valueMax: PropTypes.number,
    valueNow: PropTypes.number,
    unit: PropTypes.string,
    fullbar: PropTypes.bool,
  };

  render() {
    const { t, name, valueMin, valueMax, valueNow, unit, fullbar } = this.props;

    return (
      <div className="mt-20">
        <div className="d-flex align-items-center justify-content-between mb-8">
          <div>{name}</div>
          <div>
            {fullbar
              ? t('{{valueNow}}', { valueNow: valueNow })
              : t('{{valueNow}} / {{valueMax}}', {
                  valueNow: valueNow,
                  valueMax: valueMax,
                })}
            {unit && <span className="text-gray-700 fs-14 pl-5">{unit}</span>}
          </div>
        </div>
        <div className="progress">
          <div
            className="progress-bar"
            role="progressbar"
            aria-valuenow={valueNow}
            aria-valuemin={valueMin}
            aria-valuemax={valueMax}
            style={{
              width: (fullbar ? 1 : valueNow / valueMax) * 100.0 + '%',
            }}
          ></div>
        </div>
      </div>
    );
  }
}
export default BenefitsRowBW;
